import { SubscriptionProps } from "@aihCustomBlueprint/Handlers/AihCustomProductSubscribe/AllProductSubscriptions";
import { CustomProductSubscriptionDto } from "@aihCustomBlueprint/Handlers/AihCustomProductSubscribe/CustomProductSubscriptionDto";
import { get, request, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { ProductDto } from "@insite/client-framework/Types/ApiModels";

const subscriptionsUrl = "/api/v1/ProductSubscriptions";

export async function getSubscriptions(): Promise<ServiceResult<CustomProductSubscriptionDto[]>> {
    try {
        const response = await get<CustomProductSubscriptionDto[]>(`${subscriptionsUrl}/GetProductSubscriptions`);

        return {
            successful: true,
            result: response,
        };
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 403 || error.status === 404)) {
            return {
                successful: false,
                errorMessage: error?.errorJson?.message || error?.errorMessage || "error",
                statusCode: error.status,
            };
        }
        throw error;
    }
}

export async function getSubscriptionProducts(): Promise<ServiceResult<SubscriptionProps>> {
    try {
        const response = await get<ProductDto[] | null>(`${subscriptionsUrl}/GetSubscriptionProducts`);

        return {
            successful: true,
            result: {
                allSubscribedProducts: Array.isArray(response) ? response : [],
            },
        };
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 403 || error.status === 404)) {
            return {
                successful: false,
                errorMessage: error?.errorJson?.message || error?.errorMessage || "error",
                statusCode: error.status,
            };
        }
        throw error;
    }
}

export async function subscribeToProduct(
    productNumber: string,
): Promise<ServiceResult<CustomProductSubscriptionDto | null>> {
    try {
        const response = await request<CustomProductSubscriptionDto>(
            `${subscriptionsUrl}/CreateProductSubscription?productErpNumber=${productNumber}`,
            "POST",
        );

        return {
            successful: true,
            result: response,
        };
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 403 || error.status === 404)) {
            return {
                successful: false,
                errorMessage: error?.errorJson?.message || error?.errorMessage || "error",
                statusCode: error.status,
            };
        }
        throw error;
    }
}

export async function unsubscribeToProduct(productNumber: string): Promise<ServiceResult<string>> {
    try {
        const response = await request<string>(
            `${subscriptionsUrl}/DeleteProductSubscription?productErpNumber=${productNumber}`,
            "DELETE",
        );

        return {
            successful: true,
            result: response,
        };
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 403 || error.status === 404)) {
            return {
                successful: false,
                errorMessage: error?.errorJson?.message || error?.errorMessage || "error",
                statusCode: error.status,
            };
        }
        throw error;
    }
}

export async function getProductStatus(productNumber: string): Promise<ServiceResult<ProductDto[] | null>> {
    try {
        const response = await get<ProductDto[]>(
            `${subscriptionsUrl}/GetSubscriptionStatus?productErpNumber=${productNumber}`,
        );

        return {
            successful: true,
            result: response,
        };
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 403 || error.status === 404)) {
            return {
                successful: false,
                errorMessage: error?.errorJson?.message || error?.errorMessage || "error",
                statusCode: error.status,
            };
        }
        throw error;
    }
}

export async function getProductStatusMulti(productNumbers: string): Promise<ServiceResult<ProductDto[] | null>> {
    try {
        const response = await get<ProductDto[]>(
            `${subscriptionsUrl}/GetSubscriptionStatusMulti?productNumbers=${productNumbers}`,
        );

        return {
            successful: true,
            result: response,
        };
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 403 || error.status === 404)) {
            return {
                successful: false,
                errorMessage: error?.errorJson?.message || error?.errorMessage || "error",
                statusCode: error.status,
            };
        }
        throw error;
    }
}
